import { atom } from 'nanostores';

export class PaymentStore {
  $paymentLink = atom('');

  setPaymentLink(value) {
    this.$paymentLink.set(value);
  }
}
